export default __webpack_public_path__ + "static/media/automaint2.ad1378c8.jpg";